import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadJobseekerLookups } from 'src/app/root-store/jobseeker-store/actions';
import { AppState } from 'src/app/root-store/state';

@Component({
    selector: 'app-jobseeker-shell',
    templateUrl: './jobseeker-shell.component.html',
    styleUrls: ['./jobseeker-shell.component.scss'],
    standalone: false
})
export class JobseekerShellComponent implements OnInit {

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
    this.store.dispatch(loadJobseekerLookups());
  }
}
